"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.errors = void 0;
const defekt_1 = require("defekt");
const errors = defekt_1.defekt({
    SchemaInvalid: {},
    TypeInvalid: {}
});
exports.errors = errors;
